import { getLang, toUrlLang } from '@lingoda/env';
import { polyfillTimezones, shouldApplyPolyfillTimezone } from '@lingoda/i18n';
import { isRequirePolyfillTimezonesTest } from '@lingoda/local-feature-flags';
import './locale';

const initApplication = async () => {
    if (shouldApplyPolyfillTimezone() || isRequirePolyfillTimezonesTest()) {
        await polyfillTimezones(toUrlLang(getLang()));
    }

    // Load main file only after the polyfill is applied, so the app never formats
    // dates with the browser's outdated timezone data.
    // Eager means it's not creating a separate async chunk but instead including it in current chunk.
    await import(/* webpackMode: "eager" */ './root');
};

(function () {
    void initApplication();
})();
